/* The "Frequently Bought" app embed can't find its intended anchor on this
   theme's custom markup, so it falls back to injecting its widget into the
   footer's section-group wrapper. Rather than depend on that app's internal
   selector logic, watch for its widget wherever it lands and move it to sit
   right after the main product section — its intended spot on this page. */
(function () {
  var anchor = document.querySelector('.pb-section.pb-width');
  if (!anchor) return;

  function relocate(widget) {
    if (widget.previousElementSibling !== anchor) {
      anchor.insertAdjacentElement('afterend', widget);
    }
  }

  var existing = document.querySelector('.cbb-frequently-bought-container');
  if (existing) {
    relocate(existing);
    return;
  }

  var observer = new MutationObserver(function () {
    var widget = document.querySelector('.cbb-frequently-bought-container');
    if (widget) {
      relocate(widget);
      observer.disconnect();
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  window.setTimeout(function () {
    observer.disconnect();
  }, 15000);
})();
